/* src/app/core/modules/shared/components/spinner/spinner.component.scss */
/*# sourceMappingURL=/avvera/dev/spinner.component.css.map */
